import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import RichText from '@components/atoms/RichText';
import HeaderFont from '@components/atoms/HeaderFont';
import Link from '@components/atoms/Link';
import { dataLayerClick } from '@helpers/dataLayerPush';

const ContentBlockWithTitle = ({ data = null }) => {
  const { brandedTitle, content, link } = data;

  return (
    <Wrapper narrow>
      <Flex width="100%" pb="5rem" direction={{ base: `column`, md: `row` }}>
        <Box
          as="h3"
          flex="1"
          pb="0.532rem"
          letterSpacing="0.1rem"
          fontStyle="italic"
          color="purple.600"
          fontSize={{ base: `6xl`, md: `7xl` }}
          lineHeight={{ base: `3.75rem`, md: `4.5rem` }}
          textTransform="uppercase"
          transform="rotate(-5deg)"
          mr={{ base: `0`, md: `14` }}
          sx={{
            color: `white`,
            WebkitTextStroke: `2px #410286`,
            b: {
              WebkitTextStroke: `0`,
              color: `purple.600`
            }
          }}>
          <HeaderFont>
            <RichText data={brandedTitle.data.title} />
          </HeaderFont>
        </Box>
        <Box
          flex="1"
          fontSize={{ base: `0.875rem`, md: `md` }}
          lineHeight={{ base: `1.313rem`, md: `1.5rem` }}
          sx={{
            h3: {
              color: `purple.600`
            },
            b: {
              color: `purple.600`
            }
          }}>
          <RichText data={content.data.content} />
          {link && (
            <Link
              variant="purpleButton"
              display="inline-flex"
              key={link.id}
              href={link.url}
              width={{ base: `100%`, sm: `auto` }}
              w="auto"
              textAlign="center"
              lineHeight="unset"
              onClick={() => {
                dataLayerClick({
                  event: `cta_click`,
                  clickText: link.title,
                  clickUrl: link.url
                });
              }}>
              <HeaderFont fontWeight="700">{link.title}</HeaderFont>
            </Link>
          )}
        </Box>
      </Flex>
    </Wrapper>
  );
};

export default ContentBlockWithTitle;
